import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import { PortalName, serviceCategory, trimString } from "../../../Utils";
import { AiFillCheckCircle, AiOutlineUser } from "react-icons/ai";
import {
  GetDashboardData,
  GetWalletBalance,
} from "../../../ApiServices/Apifun";
import { MdCancel, MdPending } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import DashboardCommon from "./DashboardCommon";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cardData, setCardData] = useState({
    Total_txn: "",
    money_in: "",
    money_out: "",
    members: "",
  });
  const [spinState, setSpinState] = useState(false);
  const [collapsed, setCollapsed] = useState(["0"]);
  const [loader, setLoader] = useState(false);
  const [activeServices, setActiveServices] = useState([]);
  const [banners, setBanners] = useState([]);
  const [inActiveServices, setInactiveServices] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const walletBalance = useSelector((state) => state.B2B.walletBal);
  const heading = useSelector((state) => state.B2B.heading);
  const memberService = useSelector((state) => state.B2B.memberServices);
  const [Balance, setBalance] = useState(null);
  useEffect(() => {
    dispatch(setselectedTab("1"));
    let active = [];
    let inactive = [];
    Object.entries(serviceCategory).map(([key, val]) => {
      if (memberService.includes(val)) {
        active = [...active, key];
      } else {
        inactive = [...inactive, key];
      }
    });
    setActiveServices(active);
    setInactiveServices(inactive);
    setBalance(walletBalance);
  }, [memberService, walletBalance]);

  const getDashboard = () => {
    setLoader(true);
    GetDashboardData()
      .then((res) => {
        setBanners(res.banners);
        setAccordionData(
          res.services.map((i, index) => {
            return {
              key: index,
              label: (
                <div className="grid grid-cols-3 w-full gap-2 place-items-start">
                  <img
                    src={i.icon}
                    className="w-10 h-10 bg-white  p-1 rounded-full"
                    alt="icon"
                  />
                  <div className="text-xs col-span-2 font-medium w-full">
                    <p>{i.service_name}</p>
                    <p>Total amt: {i.total_amount} Rs.</p>
                  </div>
                </div>
              ),
              children: (
                <div className=" text-xs font-bold leading-5">
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Success</p>
                    <p className="">
                      {i.total_transactions_success} (
                      {"₹" + " " + i.total_amount_success})
                    </p>
                    <AiFillCheckCircle
                      className="bg-white  shadow-black text-green-700"
                      size={25}
                    />
                  </div>
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Pending</p>
                    <p className="">
                      {i.total_transactions_pending} (
                      {"₹" + " " + i.total_amount_pending})
                    </p>
                    <MdPending
                      className="bg-white  shadow-black text-yellow-700"
                      size={25}
                    />
                  </div>
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Failed</p>
                    <p className="">
                      {i.total_transactions_failed} (
                      {"₹" + " " + i.total_amount_failed})
                    </p>
                    <MdCancel
                      className="bg-white  shadow-black text-red-700"
                      size={25}
                    />
                  </div>
                </div>
              ),
              // showArrow: false,
            };
          })
        );
        setCardData({
          Total_txn: res.total_transactions,
          money_in: res.money_in,
          money_out: res.money_out,
          members: res.total_members,
        });
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  };
  useEffect(() => {
    getDashboard();
  }, []);
  useEffect(() => {}, [collapsed]);
  const handleGet = () => {
    setSpinState(true);
    GetWalletBalance()
      .then((res) => {
        setBalance(res.balance);
        setSpinState(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <DashboardCommon />
      {/* <div className="mb-5 p-2 bg-white rounded-md font-semibold shadow-[0px_2px_2px_#ccdcff] w-full flex justify-between items-center gap-4">
        <BsArrowLeft
          size={15}
          color={ThemeColor.primary}
          onClick={() => navigate(-1)}
          className="cursor-pointer"
        />
        <div className=" rounded-sm w-full flex text-rgbaprimary7 justify-between">
          {" "}
          <p className="py-1  rounded-md font-bold  text-[21px]">{heading}</p>
          <div className="py-1">
            <Breadcrumb
              items={[
                {
                  title: (
                    <p className="text-black font-medium">
                      <HomeOutlined /> Home
                    </p>
                  ),
                },
                {
                  title: (
                    <p className="text-rgbaprimary7 font-semibold">{heading}</p>
                  ),
                },
              ]}
            />
          </div>
        </div>

        
      </div> */}
      {/* <div className="bg-white p-8 rounded-xl mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 place-items-start">
        <div className="bg-[#5e72e4] h-[190px]  pl-8 relative animate-fade-in  w-full md:w-[90%] py-3 rounded-3xl ">
          <div className="text-white  mb-4">
            <img src={Images.circleShape} alt="circle" />
          </div>
          <p className="text-bswhite font-semibold text-2xl">
            Rs. {Balance ?? "-"}/-
          </p>
          <p className="text-white">Wallet Balance</p>
          <div
            onClick={handleGet}
            className="bg-white rounded-xl p-4 flex gap-4 cursor-pointer justify-around items-center absolute bottom-4 md:bottom-16 md:rotate-90 right-2 md:right-6"
          >
            <BiRefresh
              className={`${spinState ? "animate-spin" : ""}`}
              size={20}
            />
            <p className="text-md font-semibold ">Refresh</p>
          </div>
        </div>
    
        <div className="w-full">
          <p className="font-bold text-xl border-b-2 border-primary w-1/4">
            Services
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 place-items-start gap-8 mt-2">
            {activeServices.map((i, index) => {
              return (
                <div
                  key={index}
                  className="flex justify-around items-center gap-3  "
                >
                  <AiFillCheckCircle size={20} color={ThemeColor.bsgreen} />
                  <Tooltip title={i}>
                  <p className="font-semibold capitalize">
                    {trimString(i, 12)}
                  </p>
                  </Tooltip>
                </div>
              );
            })}
            {inActiveServices.map((i, index) => {
              return (
                <div
                  key={index}
                  className="flex justify-around items-center gap-3  "
                >
                  <FcCancel size={20} color={ThemeColor.bsred} />
                  <Tooltip title={i}>
                  <p className="font-semibold capitalize">{i}</p>
                  </Tooltip>
                </div>
              );
            })}
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Dashboard;
